/**
 * Persistência das preferências de voz, no browser.
 *
 * A FORMA das preferências vive no SDK (partilhada com o telemóvel); onde
 * ficam guardadas é de cada plataforma, porque `localStorage` é síncrono e o
 * armazenamento do React Native não é.
 *
 * Toda a leitura e escrita vai num try/catch: num separador privado, ou com
 * armazenamento bloqueado por política, o próprio acesso a `localStorage`
 * lança — e a voz tem de funcionar de qualquer forma, só sem lembrar nada.
 */
import { SETTINGS_KEY, mergeSettings, type VoiceSettings } from '@tasca/client-sdk';

export function loadSettings(): VoiceSettings {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    return mergeSettings(raw ? (JSON.parse(raw) as Partial<VoiceSettings>) : null);
  } catch {
    return mergeSettings(null);
  }
}

export function saveSettings(settings: VoiceSettings): void {
  try {
    localStorage.setItem(SETTINGS_KEY, JSON.stringify(settings));
  } catch {
    /* sem armazenamento: as preferências duram esta sessão */
  }
}
